exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cwImageWrapper img[data-v-9d00829a]{-o-object-fit:cover;object-fit:cover;width:100%;max-height:100%}", ""]);

// exports
